<template>
  <div>
    <el-form class="query-form" :model="formData" :rules="formValidateRule" :label-width="labelWidth" ref="queryForm">
      <el-row v-for="(row, index) in formatedEntityPropertys" :key="'row' + index">
        <el-col v-for="(item, itemIndex) in row" :key="'col' + itemIndex" :span="(24 / (colsOfRow * 2)) * ((item.queryColspan || item.colspan) + 1)">
          <el-form-item :label="item.chineseName" :prop="spliceAttr(item)" :key="'form-item' + itemIndex">
            <!-- 普通文本 -->
            <el-input v-if="VType(item, '01')" :placeholder="item.placeholder" style="min-width:150px;" v-model="formData[spliceAttr(item)]"></el-input>
            <!-- 整数 -->
            <el-input v-else-if="VType(item, '02')" :placeholder="item.placeholder" style="min-width:150px;" v-model="formData[spliceAttr(item)]"></el-input>
            <!-- 日期 -->
            <el-date-picker v-else-if="VType(item, '03')" v-model="formData[spliceAttr(item)]" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
            <!-- 日期时间 -->
            <el-date-picker v-else-if="VType(item, '04')" v-model="formData[spliceAttr(item)]" type="datetime" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
            <!-- 列表型字典 -->
            <dictionary v-else-if="VType(item, '05')" :dicName="item.dicName" :initValue="(formData[spliceAttr(item)] || '') + ';' + (formData[item.name + '_name'] || '')" v-model="formData[spliceAttr(item)]"></dictionary>
            <!-- 两位小数 -->
            <el-input v-else-if="VType(item, '06')" :placeholder="item.placeholder" style="min-width:150px;" v-model="formData[spliceAttr(item)]"></el-input>
            <!-- 四位小数 -->
            <el-input v-else-if="VType(item, '07')" :placeholder="item.placeholder" style="min-width:150px;" v-model="formData[spliceAttr(item)]"></el-input>
            <!-- 六位小数 -->
            <el-input v-else-if="VType(item, '08')" :placeholder="item.placeholder" style="min-width:150px;" v-model="formData[spliceAttr(item)]"></el-input>
            <!-- 多选列表形字典 -->
            <check-dictionary v-else-if="VType(item, '09')" :dicName="item.dicName" :idProperty="item.idProperty" :pidProperty="item.pidProperty" :displayProperty="item.displayProperty" v-model="formData[spliceAttr(item)]" :isCheckAll="item.isCheckAll"></check-dictionary>
            <!-- 列表字典引用 -->
            <dictionary v-else-if="VType(item, '10')" :dicName="item.dicName" :isQuote="true" :idProperty="item.idProperty" :pidProperty="item.pidProperty" :displayProperty="item.displayProperty" :initValue="(formData[spliceAttr(item)] || '') + ';' + (formData[item.name + '_name'] || '')" v-model="formData[spliceAttr(item)]"></dictionary>
            <!-- 多选列表形字典引用 -->
            <check-dictionary v-else-if="VType(item, '11')" :dicName="item.dicName" :isQuote="true" :idProperty="item.idProperty" :pidProperty="item.pidProperty" :displayProperty="item.displayProperty" v-model="formData[spliceAttr(item)]" :isCheckAll="item.isCheckAll"></check-dictionary>
            <!--树形字典-->
            <tree-dictionary v-else-if="VType(item, '12')" :dicName="item.dicName" :idProperty="item.idProperty" :pidProperty="item.pidProperty" :displayProperty="item.displayProperty" :multiple="item.multiple || false" :onlyLeaf="item.onlyLeaf || false" :disabled="item.disabled" :clearable="item.clearable" :initValue="formData[item.name] || ''" :topDm="item.topDm" :removedDm="item.removedDm" v-model="formData[spliceAttr(item)]" :isSimpleValue="item.isSimpleValue" :filterDm="item.filterDm" :checkStrictly="item.checkStrictly" :allDmList="item.allDmList" placeholder="请选择" :isShowValue="item.isShowValue"></tree-dictionary>
            <!--多选树形字典-->
            <tree-dictionary v-else-if="VType(item, '13')" :dicName="item.dicName" :idProperty="item.idProperty" :pidProperty="item.pidProperty" :displayProperty="item.displayProperty" :multiple="item.multiple || false" :onlyLeaf="item.onlyLeaf || false" :disabled="item.disabled" :clearable="item.clearable" :initValue="formData[item.name] || ''" :topDm="item.topDm" :removedDm="item.removedDm" v-model="formData[spliceAttr(item)]" :isSimpleValue="item.isSimpleValue" :filterDm="item.filterDm" :checkStrictly="item.checkStrictly" :allDmList="item.allDmList" placeholder="请选择" :isShowValue="item.isShowValue"></tree-dictionary>
            <!--树形字典引用-->
            <tree-dictionary v-else-if="VType(item, '14')" :dicName="item.dicName" :isQuote="true" :idProperty="item.idProperty" :pidProperty="item.pidProperty" :displayProperty="item.displayProperty" :multiple="item.multiple || false" :onlyLeaf="item.onlyLeaf || false" :disabled="item.disabled" :clearable="item.clearable" :initValue="formData[item.name] || ''" :topDm="item.topDm" :removedDm="item.removedDm" v-model="formData[spliceAttr(item)]" :isSimpleValue="item.isSimpleValue" :filterDm="item.filterDm" :checkStrictly="item.checkStrictly" :allDmList="item.allDmList" placeholder="请选择" :isShowValue="item.isShowValue"></tree-dictionary>
            <!--多选树形字典引用-->
            <tree-dictionary v-else-if="VType(item, '15')" :dicName="item.dicName" :isQuote="true" :idProperty="item.idProperty" :pidProperty="item.pidProperty" :displayProperty="item.displayProperty" :multiple="item.multiple || false" :onlyLeaf="item.onlyLeaf || false" :disabled="item.disabled" :clearable="item.clearable" :initValue="formData[item.name] || ''" :topDm="item.topDm" :removedDm="item.removedDm" v-model="formData[spliceAttr(item)]" :isSimpleValue="item.isSimpleValue" :filterDm="item.filterDm" :checkStrictly="item.checkStrictly" :allDmList="item.allDmList" placeholder="请选择" :isShowValue="item.isShowValue"></tree-dictionary>
            <!-- 多行文本 -->
            <el-input v-else-if="VType(item, '16')" :placeholder="item.placeholder" :rows="item.rows || 3" style="min-width:150px;" v-model="formData[spliceAttr(item)]"></el-input>
            <!-- 选择文件 -->
            <div v-else-if="VType(item, '17')">文件输入，待添加功能</div>
            <!-- 文件添加 -->
            <div v-else-if="VType(item, '18')">文件添加，待添加功能</div>
            <!-- 图片添加 -->
            <div v-else-if="VType(item, '19')">图片添加，待添加功能</div>
            <!-- 反向列表型字典 -->
            <div v-else-if="VType(item, '20')">反向列表型字典，待添加</div>
            <!-- 反向列表型字典引用 -->
            <div v-else-if="VType(item, '21')">反向列表型字典引用，待添加</div>
            <!-- 时间戳 -->
            <div v-else-if="VType(item, '22')">时间戳</div>
            <!-- 地理点 -->
            <div v-else-if="VType(item, '23')">地理点</div>
            <!-- 人脸 -->
            <div v-else-if="VType(item, '24')">人脸</div>
            <!--多项checkBox列表-->
            <el-checkbox-group v-else-if="VType(item, '25')" style="min-width:150px;" v-model="formData[spliceAttr(item)]">
              <el-checkbox v-for="option in item.options" :key="option.value" :label="option.value">{{ option.label }}</el-checkbox>
            </el-checkbox-group>
            <!--单选列型字典-->
            <radio-dictionary v-else-if="VType(item, '26')" :dicName="item.dicName" :idProperty="item.idProperty" :pidProperty="item.pidProperty" :displayProperty="item.displayProperty" v-model="formData[spliceAttr(item)]"></radio-dictionary>
            <!--两级树形字典-->
            <tree-dictionary v-else-if="VType(item, '27')" :dicName="item.dicName" :idProperty="item.idProperty" :pidProperty="item.pidProperty" :displayProperty="item.displayProperty" :multiple="item.multiple || false" :onlyLeaf="item.onlyLeaf || false" :disabled="item.disabled" :clearable="item.clearable" :initValue="formData[item.name] || ''" :topDm="item.topDm" :removedDm="item.removedDm" v-model="formData[spliceAttr(item)]" :isSimpleValue="item.isSimpleValue" :filterDm="item.filterDm" :checkStrictly="item.checkStrictly" :allDmList="item.allDmList" placeholder="请选择" :isShowValue="item.isShowValue"></tree-dictionary>
            <!--三级树形字典-->
            <tree-dictionary v-else-if="VType(item, '28')" :dicName="item.dicName" :idProperty="item.idProperty" :pidProperty="item.pidProperty" :displayProperty="item.displayProperty" :multiple="item.multiple || false" :onlyLeaf="item.onlyLeaf || false" :disabled="item.disabled" :clearable="item.clearable" :initValue="formData[item.name] || ''" :topDm="item.topDm" :removedDm="item.removedDm" v-model="formData[spliceAttr(item)]" :isSimpleValue="item.isSimpleValue" :filterDm="item.filterDm" :checkStrictly="item.checkStrictly" :allDmList="item.allDmList" placeholder="请选择" :isShowValue="item.isShowValue"></tree-dictionary>
            <!--单选radio选项-->
            <el-radio-group v-else-if="VType(item, '29')" style="min-width:150px;" v-model="formData[spliceAttr(item)]" @change="$emit('change')">
              <el-radio v-for="option in item.options" :key="option.value" :label="option.value">{{ option.label }}</el-radio>
            </el-radio-group>
            <!-- 单选select选择框 -->
            <!-- <el-select v-else-if="VType(item, '29')" placeholder="请选择" style="min-width:150px;" v-model="formData[spliceAttr(item)]">
              <el-option v-for="option in item.options" :key="option.value" :label="option.label" :value="option.value"></el-option>
            </el-select>-->
            <div v-else-if="VType(item, '30')">分组标签无数输入，待拓展</div>
            <!--选择框字典，下拉全部显示-->
            <select-dictionary v-else-if="VType(item, '31')" :dicName="item.dicName" :idProperty="item.idProperty" :pidProperty="item.pidProperty" :displayProperty="item.displayProperty" v-model="formData[spliceAttr(item)]"></select-dictionary>
            <!-- 时间选择器组件 -->
            <tm-date-picker v-else-if="VType(item, '50')" v-model="formData[spliceAttr(item)]" :type="item.type" :clearable="item.clearable"></tm-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import Dictionary from '@/components/dictionary/dictionary'
import TreeDictionary from '@/components/dictionary/tree-dictionary'
import radioDictionary from '@/components/dictionary/radio-dictionary'
import checkDictionary from '@/components/dictionary/checkbox-dictionary'
import SelectDictionary from '@/components/dictionary/select-dictionary'
import TmDatePicker from '@/components/triman/tm-date-picker'

export default {
  name: 'QueryFormBuilder',
  components: {
    Dictionary,
    TreeDictionary,
    radioDictionary,
    checkDictionary,
    SelectDictionary,
    TmDatePicker
  },
  props: {
    entityPropertys: {
      type: Array,
      default: function() {
        return []
      }
    },
    formData: {
      type: Object,
      default: function() {
        return {}
      }
    },
    formValidateRule: {
      type: Object,
      default: function() {
        return {}
      }
    },
    colsOfRow: {
      type: Number,
      default: 2
    },
    formStatus: {
      type: Number,
      default: 1
    },
    labelWidth: {
      type: String,
      default: '150px'
    }
  },
  data() {
    return {
      pickerOptions2: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      }
    }
  },
  computed: {
    formatedEntityPropertys: function() {
      let cols = 0

      const newEntityPropertys = this.entityPropertys
        .filter(item => {
          if (item.appearPlace.indexOf('02') !== -1) {
            return true
          } else {
            return false
          }
        })
        .map((item, index) => {
          if (cols % (this.colsOfRow * 2) === 0) {
            item.rowBegin = true
          } else {
            item.rowBegin = false
          }
          if (typeof item.queryColspan !== 'undefined') {
            cols = cols + item.queryColspan + 1
          } else {
            cols = cols + item.colspan + 1
          }
          return item
        })

      if (newEntityPropertys.length === 0) {
        return []
      }

      const formatedEntityPropertys = []

      let newRowItems = [newEntityPropertys[0]]
      formatedEntityPropertys.push(newRowItems)
      for (let i = 1; i < newEntityPropertys.length; i++) {
        if (newEntityPropertys[i].rowBegin) {
          newRowItems = [newEntityPropertys[i]]
          formatedEntityPropertys.push(newRowItems)
        } else {
          newRowItems.push(newEntityPropertys[i])
        }
      }
      return formatedEntityPropertys
    }
  },

  methods: {
    querySearchAsync(queryString, cb, b) {
      cb([])
      console.log(queryString)
      console.log(b)
    },
    handleSelect(item) {
      console.log(item)
    },
    resetForm() {
      console.log(this.$refs['form'])
      this.$refs['form'].resetFields()
    },
    //拼接查询字段
    spliceAttr(item) {
      return item.querySymbol + '_' + item.name
    },
    VType(item, type) {
      return item.inputType === type
    }
  },
  watch: {
    formData: {
      immediate: true,
      handler(val, oldVal) {
        // if (Object.keys(val).length === 0) {
        this.entityPropertys.forEach(element => {
          // 用来解决checkbox绑定数组问题
          if (element.inputType === '25' && !(this.formData[element.querySymbol + '_' + element.name] instanceof Array)) {
            this.$set(this.formData, element.querySymbol + '_' + element.name, [])
          }
        })
      }
    }
  }
}
</script>
<style scoped></style>
